export const ENV_VALUES = {
  'backend-path': process.env.GATSBY_BACKEND_PATH || '',
  'email-service-host': process.env.GATSBY_EMAIL_SERVICE_HOST || '',
  'raecapcha-sitekey': process.env.GATSBY_RECAPTCHA_SITEKEY || '',
  'feature-is-lead-form': process.env.GATSBY_FEATURE_IS_LEAD_FORM || '',
};
